import React, { useState } from "react";
import { Star } from "@mui/icons-material";
import {
  Box,
  LinearProgress,
  MenuItem,
  Popover,
  Select,
  Typography,
} from "@mui/material";
import { ReactComponent as LinearGraph } from "../../../assets/icons/linear-graph.svg";
import { styles } from "../../../assets/MUIStyles/callSettings";

const ModelSelector = ({ model, modelOptions, setState, findName }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [hoveredModel, setHoveredModel] = useState<any>(null);
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [disableHover, setDisableHover] = useState(false);

  const handleClosePopover = () => {
    setPopoverOpen(false);
    setHoveredModel(null);
    setAnchorEl(null);
  };

  return (
    <>
      <Typography className=" font-14-grey">Model</Typography>

      <Select
        value={
          modelOptions.some((option) => option.value === model) ? model : ""
        }
        variant="outlined"
        displayEmpty
        onChange={(e) => {
          setState((prev) => ({
            ...prev,
            model: e.target.value,
          }));

          setPopoverOpen(false);
          setHoveredModel(null);
          setAnchorEl(null);

          setDisableHover(true);
          setTimeout(() => {
            setDisableHover(false);
          }, 300);
        }}
        onClose={handleClosePopover}
        fullWidth
        sx={styles.selectField}
      >
        {modelOptions?.map((option: any) => (
          <MenuItem
            key={option?.name}
            value={option?.value}
            onMouseEnter={(e) => {
              if (!disableHover) {
                setAnchorEl(e.currentTarget);
                setHoveredModel(option);
                setPopoverOpen(true);
              }
            }}
          >
            {/* {option?.name} */}
            {findName("models", option?.name)}
          </MenuItem>
        ))}
      </Select>

      <Popover
        open={popoverOpen}
        anchorEl={anchorEl}
        onClose={handleClosePopover}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        sx={{ transform: "translateX(-10px)" }}
      >
        {hoveredModel && (
          <Box sx={styles.hoveredModelCard}>
            <Typography
              className="font-14-grey"
              sx={{
                px: 2,
                pb: 1,
              }}
            >
              {findName("models", hoveredModel?.name)}
            </Typography>

            <Box sx={styles.voiceStatusContainer}>
              <Box
                className="flex-align-center"
                sx={{
                  my: 1,
                  gap: 1,
                }}
              >
                <Star fontSize="small" sx={{ color: "gold" }} />
                <Typography className="font-13-lightgrey">Best for</Typography>
              </Box>

              <Box sx={styles.voiceGridContainer}>
                {hoveredModel?.useCases?.map((useCase, index) => (
                  <Typography
                    key={index}
                    component="li"
                    sx={{
                      fontSize: "11px",
                      color: "#555555",
                      listStyle: "disc",
                    }}
                  >
                    {useCase}
                  </Typography>
                ))}
              </Box>
            </Box>
            <Box
              className="flex-column"
              sx={{
                px: 2,
                pt: 1,
                pb: 3,
                gap: 0.5,
              }}
            >
              <Box
                className="flex-align-center"
                sx={{
                  my: 1,
                  gap: 1,
                }}
              >
                <LinearGraph />
                <Typography className="font-13-darkgrey">Latency</Typography>
              </Box>

              <LinearProgress
                variant="determinate"
                value={hoveredModel?.latency * 10}
                sx={{ color: "#5B6CE9", height: 5, borderRadius: 4 }}
              />
            </Box>
          </Box>
        )}
      </Popover>
    </>
  );
};

export default ModelSelector;
